import { useState } from 'react';
import { useSolicitacaoQuery } from '../../../hooks/data';
import { TIPO_SOLICITACAO_LABELS } from '../../NovaSolicitacaoPage/novaSolicitacaoPage.definitions';
import { STATUS_SOLICITACAO_LABELS, STATUS_SOLICITACAO_BADGE_CLASS } from '../../SolicitacoesListPage/solicitacoesListPage.definitions';
import SolicitacaoDrawer from '../../SolicitacoesListPage/components/SolicitacaoDrawer';

interface SolicitacaoRelacionadaInfoProps {
  solicitacaoRelacionadaId: string;
}

/** Só leitura — o vínculo em si é feito ao cancelar (ver CancelarSolicitacaoModal), não
 * aqui (decisão de produto: o SI só precisa disso no momento de cancelar por já existir
 * outra Solicitação em andamento). Mostrado dentro do bloco "Motivo do cancelamento".
 *
 * Abre num drawer (por cima do conteúdo atual, seja ele a página cheia ou outro drawer)
 * em vez de navegar pra `/si/solicitacoes/:id` — mantém consistência com o resto do módulo,
 * onde a lista sempre abre solicitações em drawer (ver SolicitacoesListPage). */
export default function SolicitacaoRelacionadaInfo({ solicitacaoRelacionadaId }: SolicitacaoRelacionadaInfoProps) {
  const { data: relacionada } = useSolicitacaoQuery(solicitacaoRelacionadaId);
  const [drawerAberto, setDrawerAberto] = useState(false);

  if (!relacionada) return null;

  return (
    <div className="mt-3 border-t border-gray-200 pt-3">
      <p className="text-xs font-medium uppercase text-gray-400">Solicitação relacionada</p>
      <button
        type="button"
        onClick={() => setDrawerAberto(true)}
        className="mt-1 flex w-full items-center justify-between gap-2 rounded-md border border-gray-200 bg-white p-2 text-left hover:bg-gray-50"
      >
        <p className="text-sm font-medium text-gray-900">
          {TIPO_SOLICITACAO_LABELS[relacionada.tipoSolicitacao]} · {relacionada.colaboradorNome}
        </p>
        <span
          className={`shrink-0 rounded-full px-2 py-0.5 text-xs font-semibold ${STATUS_SOLICITACAO_BADGE_CLASS[relacionada.status]}`}
        >
          {STATUS_SOLICITACAO_LABELS[relacionada.status]}
        </span>
      </button>
      <SolicitacaoDrawer
        solicitacaoId={drawerAberto ? relacionada.id : null}
        onClose={() => setDrawerAberto(false)}
      />
    </div>
  );
}
